import React from 'react';
import * as cls from './reviews.module.css';
import { Typography } from '../../../ui/components/typography/typography';
import { Reviews as UIReviews } from '../../../ui/layouts/reviews';
import { IMG_PATH } from '../../../constants';

export const Reviews = ({ url }) => {
  return (
    <section className={`${cls.section} ${cls['background--contrast']}`}>
      <Typography as="h1" tag="h2">
        What Customers Say
      </Typography>

      <UIReviews shouldAnimate={false} />

      <a
        className={cls.button}
        href={url}
        rel="noopener noreferrer"
        target="_blank"
      >
        <img
          alt="Order Now on Amazon"
          src={`${IMG_PATH}/amazon-shop/order-now-on-amazon.png`}
        />
      </a>
    </section>
  );
};
